import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Menu, MenuItem, TextField, Popover, Typography } from '@material-ui/core';
import { map } from 'lodash';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import SvgList from '../../../components/SvgList.jsx';
import Popup from '../../../components/Popup/index.js';
import { Button } from '../../../components/index.jsx';
import { songActions } from '../../../actions/index.js';
import { formatDateToDisplay } from '../../../utils/index.js';

import '../ArtistDetailsUploadedMusic.scss';
import PlayListThumbnail from '../../../components/PlayListThumbnail/index.js';

const UploadMusicRow = ({ song, index, makeSongApprove, makeSongDecline }) => {
  const history = useHistory();

  const [selectedItemId, setSelectedItemId] = useState(1);
  const [approveAnchorEl, setApproveAnchorEl] = React.useState(null);
  const [declineAnchorEl, setDeclineAnchorEl] = React.useState(null);
  const [approvePopup, setApprovePopup] = useState(false);
  const [rejectPopUp, setRejectPopup] = useState(false);
  const [reason, setReason] = useState('');
  const [isConfirm, setIsConfirm] = useState(false);

  const approveOpen = Boolean(approveAnchorEl);
  const declineOpen = Boolean(declineAnchorEl);

  const handleDeclineClick = (event) => {
    event.stopPropagation();
    setDeclineAnchorEl(event.currentTarget);
  };

  const handleApproveClose = () => {
    setApproveAnchorEl(null);
  };

  const handleDeclineClose = () => {
    setDeclineAnchorEl(null);
  };

  const handleRejectButtonClick = (id) => (e) => {
    e.stopPropagation();
    setRejectPopup(true);
    setSelectedItemId(id);
    setReason('');
  };

  const handleApproveButtonClick = (id) => (e) => {
    e.stopPropagation();
    setApprovePopup(true);
    setSelectedItemId(id);
  };

  const handelApproveSong = async () => {
    setIsConfirm(true);
    const isSucess = await songActions.updateSong(selectedItemId, { submission_status: 'ACCEPTED' });
    if (!isSucess) return;
    if (isSucess) {
      makeSongApprove(selectedItemId);
      setIsConfirm(false);
      setApprovePopup(false);
    }
  };

  const handleRejectSong = async () => {
    setIsConfirm(true);
    const isSucess = await songActions.updateSong(selectedItemId, { submission_status: 'REJECTED', decline_reason: reason });
    if (!isSucess) return;
    if (isSucess) {
      makeSongDecline(selectedItemId, reason);
      setRejectPopup(false);
      setIsConfirm(false);
    }
  };

  return (
    <>
      <TableRow
        key={song.id}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          console.log(song.id, 'song.id');
          history.push(`/songs/song-detial?id=${song.id}`);
        }}
      >
        <TableCell className="result">
          <div style={{ display: 'flex', columnGap: 30, alignItems: 'center' }}>
            <span>#{index + 1}</span>
            <PlayListThumbnail src={song.thumbnail_img} name={song.title} style={{ borderRadius: 6 }} />
          </div>
        </TableCell>
        <TableCell>{song.title}</TableCell>
        <TableCell>{song.artist_name}</TableCell>
        <TableCell>{formatDateToDisplay(song.created_at)}</TableCell>
        <TableCell className="status">
          <div style={{ display: 'flex', columnGap: 10 }}>
            {song.submission_status === 'PENDING' && (
              <div className="button-group">
                <button className="button reject" style={{ '--button-color': '#DD4E47' }} onClick={handleRejectButtonClick(song.id)}>
                  Reject
                </button>
                <button style={{ '--button-color': '#6B3EB4' }} className="button accept" onClick={handleApproveButtonClick(song.id)}>
                  Accept
                </button>
              </div>
            )}

            {song.submission_status === 'REJECTED' && (
              <div className="button-group" style={{ alignItems: 'center' }}>
                <button
                  aria-describedby={'decline-popover'}
                  variant="contained"
                  onClick={handleDeclineClick}
                  className="button decline"
                  style={{ '--button-color': '#DD4E47', display: 'flex', alignItems: 'center', columnGap: 10 }}
                >
                  Declined
                  <SvgList name="question-icon" />
                </button>

                <Popover
                  id={'decline-popover'}
                  open={declineOpen}
                  anchorEl={declineAnchorEl}
                  onClose={handleDeclineClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  PaperProps={{
                    style: {
                      width: '264px',
                      padding: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: 8,
                      background: '#FFF',
                      boxShadow: '2px 2px 8px 2px rgba(0, 0, 0, 0.10)',
                    },
                  }}
                >
                  <Typography>{song.decline_reason}</Typography>
                </Popover>

                <div className="switch" onClick={handleApproveButtonClick(song.id)}>
                  <SvgList name="switch-icon" />
                </div>
              </div>
            )}

            {song.submission_status === 'ACCEPTED' && (
              <div className="button-group" style={{ alignItems: 'center' }}>
                <button
                  aria-describedby={'approve-popover'}
                  variant="contained"
                  // onClick={handleApproveClick}
                  className="button approve"
                  style={{ '--button-color': '#DD4E47', display: 'flex', alignItems: 'center', columnGap: 10 }}
                >
                  Approved
                </button>

                <Popover
                  onClick={() => setApprovePopup(false)}
                  id={'approve-popover'}
                  open={approveOpen}
                  anchorEl={approveAnchorEl}
                  onClose={handleApproveClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  PaperProps={{
                    style: {
                      width: '182px',
                      padding: '8px 24px',
                      height: '56px',
                      display: 'flex',
                      alignItems: 'center',
                    },
                  }}
                >
                  <Typography>Approve this song</Typography>
                </Popover>
                <div className="switch" onClick={handleRejectButtonClick(song.id)}>
                  <SvgList name="switch-icon" />
                </div>
              </div>
            )}
          </div>
        </TableCell>
      </TableRow>

      <Popup open={approvePopup} onClose={() => !isConfirm && setApprovePopup(false)}>
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to approve this song?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button onClick={() => setApprovePopup(false)} className="button transparent">
            Cancel
          </Button>
          <Button isLoading={isConfirm} onClick={handelApproveSong} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>

      <Popup open={rejectPopUp} onClose={() => !isConfirm && setRejectPopup(false)}>
        <div style={{ width: 470 }}>
          <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
            Rejection reason
          </h4>
          <TextField
            label="Enter the reason why you are rejecting this song"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            style={{ marginBottom: 20 }}
          />
          <div className="button-group" style={{ '--button-color': '#6900af' }}>
            <Button onClick={() => setRejectPopup(false)} className="button transparent">
              Cancel
            </Button>
            <Button isLoading={isConfirm} onClick={handleRejectSong} className="button primary">
              Confirm
            </Button>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default UploadMusicRow;

